export default __webpack_public_path__ + "static/media/company-employees.60dc2d16.csv";